<template>
  <v-dialog
    v-model="dialog"
    @keydown.esc="dialog = false"
    @click:outside="dialog = false"
    persistent
    max-width="650"
  >
    <div id="modalform" tabindex="-1" ref="modalform">
      <v-card>
        <v-card-title
          style="
            color: #02b28a;
            font-weight: 700;
            justify-content: space-between;
            background: #effaf4;
          "
        >
          <div></div>
          <div>職員配置エラー</div>
          <div><button class="btn_close" @click="dialog = false">✕</button></div>
        </v-card-title>
        <v-card-text style="padding: 30px 70px">
          <div
            v-for="(val, date) in filterd_days_hope_holiday_error"
            v-if="Object.keys(val).length > 0"
          >
            <p>
              {{ date }}
            </p>
            <p v-if="val.hope_holiday && val.hope_holiday.error">
              希望休の重複により日ごとに必要な職員を配置できません。
            </p>
            <p v-for="(values, workpatter_id) in val.setting_and_staff_count">
              {{ values.workpattern_name }} が{{ values.difference_count }}名分不足しています。
              (希望の配置人数 {{ values.total_max_min_setting.min }} -
              {{ values.total_max_min_setting.max }})
            </p>
          </div>
          <!-- 〇/〇 希望休の重複により日ごとに必要な職員を配置できません<br>〇/〇 希望休の重複により日ごとに必要な職員を配置できません -->
        </v-card-text>

        <v-card-text style="padding: 30px 70px">
          <p class="title_green_line">■ 解消方法</p>
          <p>職員の休暇を調整してください。</p>
        </v-card-text>

        <v-card-actions style="padding: 0">
          <v-spacer></v-spacer>
          <div
            style="display: flex; justify-content: center; width: 100%; padding: 0px 70px 70px 70px"
          >
            <button
              class="btn_gray_shadow"
              style="width: 150px; padding: 5px 0"
              @click="dialog = false"
            >
              閉じる
            </button>
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<style scoped>
a {
  color: #1059cc !important;
  text-decoration: underline !important;
}
a:hover {
  cursor: pointer;
}
</style>

<script>
export default {
  name: 'AlertHopeHolidayDialog',
  components: {},
  props: {
    filterd_days_hope_holiday_error: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      console.log(this.filterd_days_hope_holiday_error);
      this.dialog = true;
    },
  },
  computed: {},
  mounted() {},
};
</script>
